import { styled } from '@mui/material'

import TypographyWrapper from '../wrapper/TypographyWrapper'

export const LabelInputUserAge = styled(TypographyWrapper)(({ theme }) => ({
  color: theme.palette.tertiary?.dark,
  fontFamily: 'Helvetica',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal'
}))
